import { render, staticRenderFns } from "./RoundWinLose.vue?vue&type=template&id=8767b018&"
import script from "./RoundWinLose.vue?vue&type=script&lang=js&"
export * from "./RoundWinLose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports